import React, { useContext, useEffect, useState } from "react";
import ControlContext from "../../contexts/control-context";
import './LayersPalette.css'

const LayersPalette = () => {

    const {
        changeCurrMode,
        shapes,
        shapesMap,
        selectShape,
        reorderLayers,
        selectedShapeId,
        selectedFrameId,
        updateShapeProps
    } = useContext(ControlContext);

    const [draggingId, setDraggingId] = useState()
    const [oldIdx, setOldIdx] = useState()

    const [editState, setEditState] = useState(false)

    let drag = (e, id) => {
        let ghost = document.getElementById("ghostlayer")

        e.dataTransfer.setDragImage(ghost, 0, 0);

        setDraggingId(id)
        let idx = shapes.indexOf(id)
        setOldIdx(idx)
    }

    let dragOver = (e, newId) => {
        e.preventDefault()
        e.dataTransfer.dropEffect = "move"

        let from = shapes.indexOf(draggingId)
        let to = shapes.indexOf(newId)
        reorderLayers(from, to)
    }

    let drop = () => {
        if (draggingId) {
            reorderLayers(oldIdx, shapes.indexOf(draggingId), true)
        }
        setOldIdx(undefined)
        setDraggingId(undefined)
    }

    let getStyle = (id) => {
        let style = {}
        if (selectedShapeId === id) {
            style.outline = "solid lightblue"
        }
        if (draggingId === id) {
            style.display = "block"
            style.boxShadow = "3px 3px 10px 2px gray"
            style.WebkitBoxShadow = "3px 3px 10px 2px gray"
            style.transform = "scale(1.02, 1.02)"
        }
        return style
    }

    return (
        // layers tab of left panel
        <div id="layers-palette">
            <table id="layers">
                {shapes.filter((id) => shapesMap[id] && shapesMap[id].visible && shapesMap[id].frame === selectedFrameId)
                           .reverse()
                           .map((id, i) => {
                        let shape = shapesMap[id]
                        return (<tbody className="layer"
                                        draggable="true"
                                        onDragStart={(event) => drag(event, id)}
                                        onDragOver={(event) => dragOver(event, id)}
                                        onDrop={drop}
                                        onDragEnd={drop}
                                        key={id} 
                                        onMouseDown={(event) => {
                                            event.stopPropagation(); 
                                            selectShape(id); 
                                            changeCurrMode("select")}}
                                        style={getStyle(id)}
                                    >
                                    <tr onDoubleClick={(e) => {setEditState(!editState)}}>
                                        <td style={{padding: '5px'}} className="layer">
                                                {editState ? 
                                                <input type="text" 
                                                    defaultValue={shape.name}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter"){
                                                            updateShapeProps(selectedShapeId, { name: e.target.value } )
                                                            setEditState(false);
                                                        }
                                                    }}
                                        ></input> : <div>{shape.name}</div>}
                                    </td>
                                </tr>
                            </tbody>)})}
                <tbody>
                    <tr id="ghostlayer" style={{opacity: "0", width:"100%", height:"1px", visibility: "hidden"}}></tr>
                </tbody>
            </table>
        </div>
    )

}

export default LayersPalette;